/*                              @Author : {}
 * Copyright (c) 2021, by Tush Entertainment
 * Permission to use, copy, modify or distribute this software in binary or source form
 * for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
 * THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
 * ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
 * BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
 * DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
 * PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
 * SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
 * ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
 * PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../logo/moovi.png";
import "../css/App.css";
import "../css/Home.css";
import { BrowserRouter as Router, Link } from "react-router-dom";
//code start from here
const Sidenav = (props) => {
  const [flag, setflag] = useState(false);
  useEffect(() => {
    var role = localStorage.getItem("role");
    if (role === "BACKOFFICE") {
      setflag(false);
    } else {
      setflag(true);
    }
  }, []);

  let navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
        <div className={props.show ? "home" : "home active"}>
          {/* <span  className="xman" onClick={props.icon}>X</span> */}
          <div className={props.show ? "logo active" : "logo"}>
           <img src={logo} /> 
          </div>
          <div className="SideNav">
            {flag ? (
              <>
                <div className="flex">
                  <Link to="/admin/dashboard" >
                   <span><i className="fa fa-th-large" /></span> 
                    <span>Dashboard</span>
                  </Link>
                </div>
                <div className="flex">
                  <Link to="/config">
                  <span><i className="fa fa-server" /></span>
                    <span>Configuration</span>
                  </Link>
                </div>
                <div className="flex">
                  <Link to="/subcription">
                  <span><i className="fa fa-cube"></i></span>
                    <span>Subscription</span>
                  </Link>
                </div>
                <div className="flex">
                  <Link to="/payment" >
                  <span><i className="fa fa-credit-card" /></span>
                    <span>Payment Gateway</span>
                  </Link>
                </div>
              </>
            ) : (
              <></>
            )}
            <div className="flex">
              <Link to="/reels" >
              <span><i className="fa fa-free-code-camp" /></span>
                <span>Reels</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/category" >
              <span><i className="fa fa-th" /></span>
                <span>Categories</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/posters" >
              <span><i className="fa fa-file-image" /></span>
                <span> Posters</span>{" "}
              </Link>
            </div>
            <div className="flex">
              <Link to="/content" >
              <span><i className="fa fa-film" /></span>
                <span>Content</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/upcomming/content">
              <span><i className="fa fa-photo-video" /></span>
                <span>Upcoming</span>
              </Link>
            </div>

            <div className="flex">
              <Link to="/support" >
              <span><i className="fa fa-ticket" /></span>
                <span>Support Ticket</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/users" >
              <span><i className="fa fa-users" /></span>
                <span>Users</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/notification/promotional" >
              <span><i className="fa fa-bell" /></span>
                <span>Notification</span>
              </Link>
            </div>
            <div className="flex">
              <Link to="/release/management" >
              <span><i className="fa fa-android" /></span>
                <span>Release Management</span>
              </Link>
            </div>
            {/* <div className="flex">
              <Link to="/inapp/android/list" >
              <span><i className="fa fa-android" /></span>
                <span>In-App PlayConsole</span>
              </Link>
            </div> */}

            <div className="flex">
              <span onClick={logout} >
              <Link to="#">
              <span><i className="fa fa-sign-out-alt" /></span>
                <span>Logout</span>
                </Link>
              </span>
              
            </div>
          </div>
        </div>
    </>
  );
};
export default Sidenav;